module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_footer_image_03-02ce2b8324c0b86619a5ef68a9d73c3b.jpg";